module.exports = __webpack_public_path__ + "static/bg-showcase-3-c1238009586a429754517f30cb040194.jpg";